import { apiClient } from "@api/client";
import { request } from "@api/request";
import type { components } from "@api/schema";

export interface Room {
  id: string;
  name: string;
  active: boolean;
}

export const toRoom = (r: components["schemas"]["RoomOut"]): Room => ({
  id: r.uuid,
  name: r.name,
  active: r.active,
});

export const roomsClient = {
  /**
   * The clinic's rooms. Pass `active: true` to drop deactivated rooms (the
   * room switcher / grid only wants live ones); omit to fetch every room.
   */
  list: (opts?: { active?: boolean }): Promise<Room[]> =>
    request(() =>
      apiClient.GET("/rooms", {
        params: {
          query: opts?.active === undefined ? {} : { active: opts.active },
        },
      }),
    ).then((rows) => rows.map(toRoom)),
};
